<template>
  <div class="sidebar">
    <div class="guanggao">

      <img src="../assets/school/guanggao1.png" @click="goUrl('/aiList')">

      <img src="../assets/school/guanggao2.png" @click="goUrl('/rank')">
    </div>
    <div class="remen">
      <div class="title1 flex">
        <span style="text-indent: 18px;">大学排行</span>
        <div class="more"><span>更多</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="remenlist">
        <ul>
          <li v-for="(item,index) in school" class="flex" @click="goDetail(item)">
            <div>
              <span class="rank">{{index+1}}</span>
              <span class="name">{{item.school_name}}</span>
            </div>
            <span class="hot">{{item.hot}}热度</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        data: [],
        school: []
      }
    },
    created() {
      this.$http.hotRankSchool().then(res => {
        this.school = res.data.list
      })
    },
    methods: {
      goDetail(item) {
        this.$router.push('/schoolDetail?id=' + item.id)
      },
      goUrl(url, num) {
        this.activeIndex = url
        localStorage.setItem('activeurl', url)
        this.$router.push({
          path: url
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .sidebar {
    width: 309px;
    margin-top: 20px;
  }

  .remen {
    .more {
      display: inline-block;
      float: right;
    }

    .right {
      width: 300px;
      float: left;
      margin-top: 33px;
      margin-left: 40px;
    }

    .block {
      margin: 51px 0 0 26px;
    }

    .left {
      margin-top: 31px;
      width: 70%;
      float: left;
    }

    .title {
      width: 100px;
      position: relative;
      line-height: 18px;
    }

    .title1 {
      margin-top: 42px;
      position: relative;
      line-height: 18px;
      justify-content: space-between;
    }

    .title::before {
      content: "";
      width: 4px;
      height: 18px;
      position: absolute;
      top: 0;
      left: 0;
      background: #C10B17;
    }

    .title1::before {
      content: "";
      width: 4px;
      height: 18px;
      position: absolute;
      top: 0;
      left: 0;
      background: #C10B17;
    }

    ul {
      margin-top: 30px;
    }

    li {
      width: 100%;
      margin-bottom: 23px;
      text-align: left;
      line-height: 34px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
    }

    .hot {
      color: #FFA200;

    }

    .rank {
      width: 20px;
      height: 20px;
      background: #C10B17;
      display: inline-block;
      color: #FFFFFF;
      line-height: 20px;
      text-align: center;
    }

    .rank1 {
      // background: url(../assets/school/2.png);
    }

    .rank2 {
      background: url(../assets/school/3.png);
    }

    .rank3 {
      background: #F2F2F2;
    }
  }

  .right {
    position: absolute;
    right: 0px;
    top: 0;

    .guanggao {
      img {
        display: block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue